import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { team as teamService } from 'services';
import { getTeamsSuccess, getTeamsFailure } from './actions';
import { TeamLocalActionTypes } from './types';

export function* handleGetTeams(request: any) {
  try {
    const response: AxiosResponse = yield call(
      teamService.getTeams,
      request.payload
    );
    if (response?.data) {
      yield put(getTeamsSuccess(response.data));
    } else {
      yield put(getTeamsFailure('Unable to fetch User Teams'));
    }
  } catch (error) {
    const errMsg = Axios.isAxiosError(error)
      ? error.response?.data?.msg
      : undefined;
    yield put(getTeamsFailure(errMsg || 'Unable to fetch User Teams'));
  }
}

export function* onGetTeams() {
  yield takeLatest(TeamLocalActionTypes.GET_TEAMS_START, handleGetTeams);
}

export function* sagas() {
  yield all([call(onGetTeams)]);
}

export default sagas;
